import * as api from '../api';

export const getDataFromServer = (slug_id) => {
  const endpoint = `/projects/${slug_id}/about`;
  return api.get(endpoint);
};
